import { type Actions, ActionType } from './favorite-activities.actions';
import { favoriteActivitiesAdapter, initialState, type State } from './favorite-activities.state';

export function favoriteActivitiesReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return { ...initialState };
        }

        case ActionType.FETCH_FAVORITE_ACTIVITIES: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.FETCH_FAVORITE_ACTIVITIES_SUCCEEDED: {
            return favoriteActivitiesAdapter.setAll(action.payload.favoriteUserActivities, {
                ...state,
                isPending: false,
                isLoaded: true
            });
        }

        case ActionType.FETCH_FAVORITE_ACTIVITIES_FAILED: {
            return {
                ...state,
                isPending: false
            };
        }

        case ActionType.CREATE_FAVORITE_ACTIVITY: {
            return favoriteActivitiesAdapter.addOne(action.payload.favoriteUserActivity, state);
        }

        case ActionType.DELETE_FAVORITE_ACTIVITY: {
            return favoriteActivitiesAdapter.removeOne(action.payload.favoriteId, state);
        }

        default:
            return state;
    }
}
